<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <form novalidate>
        <div class="rightSidePanel active w-50pc">
            <header class="panel-header">
                <div class="viewDemo title-and-video">
                    <h2>{{this.panelHeading}}
                        <span *ngIf="this.journeyFormModel">
                            ({{ 'text_leg' | translate }} - {{this.journeyFormModel && this.journeyFormModel.sequence}})
                        </span>
                    </h2>
                </div>            
                <div class="panel-left-btn">
                    <button type="button" class="btn eod-btn-outline-warning mr-2" *ngIf="this.inputModel && this.inputModel.isEditMode" (click)="fnShowDeleteConfirmationAlert()">
                        {{ 'label_delete' | translate }}
                    </button>
                    <button type="button" class="btn eod-btn-primary mr-2" [ngClass]="{'disabled': disableSaveButton 
                        || !(this.journeyForm && this.journeyForm.form && this.journeyForm.form.dirty)}"
                        (click)="fnSaveJourneyDetails()">
                        {{ "save" | translate }}
                    </button>
                    <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                        {{ "close" | translate }}
                    </button>
                </div>
            </header>
            <div class="eod-panel-body">
                <dynamic-form [model]="journeyFormModel" [fields]="journeyFormFields"></dynamic-form>
            </div>
        </div>
    </form>
</div>


<app-alert-panel *ngIf="showWarningAlerts" [data]="showWarningAlertsModel"
    (callbackEvent)="fnShowWarningAlertsReceiver($event)">
</app-alert-panel>

<create-detour-panel *ngIf="showSelectDetourPanel" [inputData]="selectDetourInputModel"
    (closePanelEvent)="fnCloseSelectDetourPanel($event)" (selectItemEvent)="fnSelectDetourPanel($event)">
</create-detour-panel>

<app-alert-panel *ngIf="showDebtourNotActivatedAlertPanel" [data]="debtourNotActivatedAlertModel"
    (callbackEvent)="fnCloseDebtourNotActivatedAlertPanel($event)">
</app-alert-panel>

<add-passenger-load-panel *ngIf="showAddPassengerLoadPanel" [inputData]="passengerLoadInputModel"
    (closePanelEvent)="fnCloseAddPassengerLoadPanel($event)" (selectItemEvent)="fnSelectPassengerLoad($event)">
</add-passenger-load-panel>

<app-alert-panel *ngIf="showPassengerLoadNotActivatedAlertPanel" [data]="passengerLoadNotActivatedAlertModel"
    (callbackEvent)="fnClosePassengerLoadNotActivatedAlertPanel($event)">
</app-alert-panel>

<app-alert-panel *ngIf="showDeleteConfirmationAlert" [data]="deleteConfirmationAlertModel"
    (callbackEvent)="fnDeleteConfirmationAlertReceiver($event)">
</app-alert-panel>

<app-alert-panel *ngIf="showUnsavedChangesAlert" [data]="unsavedChangesAlertModel"
    (callbackEvent)="fnUnsavedChangesAlertReceiver($event)">
</app-alert-panel>

<app-alert-panel *ngIf="showGoogleServiceErrorPopup" [data]="GoogleServiceErrorPopupModel"
(callbackEvent)="fnGoogleServiceErrorPopupReceiver($event)">
</app-alert-panel>

<app-alert-panel *ngIf="showChargingTypeActivationAlert" [data]="chargingTypeActivationAlertModel"
    (callbackEvent)="fnChargingTypeActivationAlertReceiver($event)">
</app-alert-panel>

<app-alert-panel *ngIf="showPassengerLoadVehicleNotMappedAlert" [data]="passengerLoadVehicleNotMappedAlertModel"
    (callbackEvent)="fnPassengerLoadVehicleNotMappedAlertReceiver($event)">
</app-alert-panel>